var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoshmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8839 7.25491V16.9001L13.881 16.8977C13.881 19.7942 11.4215 22.1506 8.37888 22.1506C5.33624 22.1506 2.86914 19.7942 2.86914 16.8977C2.86914 14.2409 4.94273 12.0471 7.62544 11.7043M10.1179 16.7404V7.09584L10.119 7.09408C10.119 4.19753 12.5785 1.84943 15.6211 1.84943C18.6638 1.84943 21.1309 4.19753 21.1309 7.09408C21.1309 9.79328 18.9884 12.0212 16.2291 12.304",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoshmark);
export default __webpack_public_path__ + "static/media/poshmark.c2d41e383164df9b79ff6f7128f2aa08.svg";
export { ForwardRef as ReactComponent };